import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Row, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const get = require('lodash/get');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const SignUpActions = require('../../actions/signup_actions');
const SignUpStore = require('../../stores/signup_store_reflux');
const ValidateUtil = require('../../util/ValidateUtil');
const KeyboardUtil = require('../../util/keyboard');
const UriUtil = require('../../util/UriUtil');
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';
import SignedOutFooter from './SignedOutFooter';
import ReCaptcha from '../captcha/ReCaptcha';
import SignedOutPromoPanel from './SignedOutPromoPanel';

const propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
};
const defaultProps = {};

class SignUp extends React.Component {
    constructor(props) {
        let regToken = '';
        const pathname = get(props, ['location', 'pathname'], null)
        if (!!pathname) {
            // ex. pathname: '/signup/kidcitizen_org'
            const splitStr = pathname.split('/');
            if (!!splitStr[2]) {
                regToken = splitStr[2];
            }
        }

        super(props);
        this.state = {
            email1: "",
            email2: "",
            token: regToken,
            captchaToken: '',
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.email1OnChange = this.email1OnChange.bind(this);
        this.email2OnChange = this.email2OnChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.registerHandler = this.registerHandler.bind(this);
        this.captchaCallback = this.captchaCallback.bind(this);
        this.resetCaptcha = this.resetCaptcha.bind(this);
        this.unsubscribes = [
            SignUpStore.listen(this.onSignUpStoreChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSignUpStoreChange(newState) {
        let updatedState = ValidateUtil.getUpdatedState(this.state.actionID, newState);
        this.setState(updatedState);
    }

    email1OnChange(e) {
        this.setState({ email1: e.target.value });
    }

    email2OnChange(e){
        this.setState({ email2: e.target.value });
    }

    handleKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.registerHandler();
        }
    }

    registerHandler() {
        const query = UriUtil.parseLocationSearchString(this.props.location);
        const redirectToPath = query[Globals.uri.query.REDIRECT_TO_PATH];
        const actionID = uuid.v4();
        this.setState({ actionID: actionID}, () => {
            SignUpActions.signUp(
                actionID, 
                {
                    email1: this.state.email1,
                    email2: this.state.email2,
                    token: this.state.token,
                    captchaToken: this.state.captchaToken,
                    redirectToPath: redirectToPath,
                }
            );
        });
    }

    captchaCallback(token) {
        this.setState({ captchaToken: token });
    }

    resetCaptcha() {
        this.setState({ captchaToken: '' });
    }

    render() {
        const query = UriUtil.parseLocationSearchString(this.props.location);
        const redirectToPath = query[Globals.uri.query.REDIRECT_TO_PATH];
        const signInParams = !!redirectToPath ? `?${Globals.uri.query.REDIRECT_TO_PATH}=${encodeURIComponent(redirectToPath)}` : '';

        return (
            <div className="fill signed-out--new">
                <div className="container rel-centered-v">
                    <div className="signedOutDual">
                        <SignedOutPromoPanel />
                        <div className="signedOutDual__form">
                            <ErrorBox error={this.state.error} />
                            {(this.state.actionSuccess) && <SuccessBox message={this.state.successMessage} />}
                            <div style={this.state.actionSuccess ? {display: 'none'} : {display: 'block'}}>
                                <Form.Group controlId="signup-email1">
                                    <Form.Label>{Strings['en'].signed_out.sign_in_new.signup_form.EMAIL}</Form.Label>
                                    <Form.Control
                                        type="email"
                                        aria-label={Strings['en'].signed_out.sign_in_new.signup_form.EMAIL}
                                        onChange={this.email1OnChange}
                                        onKeyDown={this.handleKeyDown}
                                        isInvalid={ValidateUtil.isInvalid(this.state, 'email1')}
                                    />
                                </Form.Group>
                                <Form.Group controlId="signup-email2">
                                    <Form.Label>{Strings['en'].signed_out.sign_in_new.signup_form.CONFIRM_EMAIL}</Form.Label>
                                    <Form.Control
                                        type="email"
                                        aria-label={Strings['en'].signed_out.sign_in_new.signup_form.CONFIRM_EMAIL}
                                        onChange={this.email2OnChange}
                                        onKeyDown={this.handleKeyDown}
                                        isInvalid={ValidateUtil.isInvalid(this.state, 'email2')}
                                    />
                                </Form.Group>
                                <div className="text-centered margin-top-xl margin-bottom-xl">
                                    <ReCaptcha
                                        className="inline-block"
                                        callback={this.captchaCallback}
                                        expiredCallback={this.resetCaptcha}
                                    />
                                </div>
                                <div className="signedOutDual__formRememberForgot margin-top-lg">
                                    <Link to={`/signin${signInParams}`}>{Strings['en'].signed_out.sign_in_new.signup_form.ALREADY_REGISTERED}</Link>
                                </div>
                                <div className="signedOutDual__buttonRow margin-top-lg">
                                    <Button
                                        disabled={this.state.actionSuccess || !this.state.captchaToken}
                                        onClick={this.registerHandler}
                                    >
                                        {Strings['en'].signed_out.sign_in_new.signup_form.REGISTER_BTN_LBL}
                                    </Button>
                                </div>
                                <div className="margin-top-lg">
                                    <small>{Strings['en'].signed_out.sign_in_new.signup_form.NEWSLETTER_MSG}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SignedOutFooter />
            </div>
        );
    }
}

SignUp.propTypes = propTypes;
SignUp.defaultProps = defaultProps;

export default SignUp;